/* import __COLOCATED_TEMPLATE__ from './left.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();